import dayjs from 'dayjs'

export type Slot = { from: string; to: string }
export type SlotPosition = 'single' | 'start' | 'middle' | 'end' | null

const ONE_DAY_MS = 24 * 60 * 60 * 1000
const ONE_HOUR_MS = 60 * 60 * 1000

type SlotUnit = 'day' | 'hour'

const unitMs = (unit: SlotUnit) => (unit === 'day' ? ONE_DAY_MS : ONE_HOUR_MS)

// объединение слотов, которые идут один за другим

export const mergeSlots = (
  slots: Slot[] | undefined,
  unit: SlotUnit,
  zone?: string
): Slot[] => {
  const unitValue = (date: string) =>
    (zone ? dayjs(date).tz(zone) : dayjs(date)).startOf(unit).valueOf()

  const list = slots ?? []
  const sorted = [...list].sort((a, b) => unitValue(a.from) - unitValue(b.from))

  const merged: Slot[] = []

  for (const slot of sorted) {
    const last = merged.at(-1)

    if (last && unitValue(slot.from) <= unitValue(last.to) + unitMs(unit)) {
      if (unitValue(slot.to) > unitValue(last.to)) {
        last.to = slot.to
      }
      continue
    }

    merged.push({ ...slot })
  }

  return merged
}

export type RowBoundary = { isRowStart: boolean; isRowEnd: boolean }

export const getSlotPosition = (
  date: Date | dayjs.Dayjs,
  slots: Slot[] | undefined,
  unit: SlotUnit,
  isRowBoundary?: (date: Date | dayjs.Dayjs) => RowBoundary,
  zone?: string
): SlotPosition => {
  const toUnitValue = (value: Date | dayjs.Dayjs | string) =>
    (zone ? dayjs(value).tz(zone) : dayjs(value)).startOf(unit).valueOf()

  const normalizedDate = toUnitValue(date)
  const list = slots ?? []

  for (const { from, to } of list) {
    const start = toUnitValue(from)
    const end = toUnitValue(to)

    if (normalizedDate < start || normalizedDate > end) {
      continue
    }

    if (start === end) {
      return 'single'
    }

    const rowBoundary = isRowBoundary?.(date)
    const isStart =
      normalizedDate === start || (rowBoundary?.isRowStart ?? false)
    const isEnd = normalizedDate === end || (rowBoundary?.isRowEnd ?? false)

    if (isStart && isEnd) {
      return 'single'
    }
    if (isStart) {
      return 'start'
    }
    if (isEnd) {
      return 'end'
    }
    return 'middle'
  }

  return null
}
